var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 21 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82685 23.7288L1.82574 23.73C1.21857 24.3996 0.875 25.2967 0.875 26.228V31.6C0.875 33.5305 2.34774 35.125 4.16667 35.125H16.8333C18.6523 35.125 20.125 33.5305 20.125 31.6V26.228C20.125 25.297 19.7816 24.3991 19.1731 23.7458L13.8375 18.0002L19.1572 12.3053L19.1573 12.3052C19.7813 11.6352 20.125 10.7374 20.125 9.806V4.4C20.125 2.46948 18.6523 0.875 16.8333 0.875H4.16667C2.34774 0.875 0.875 2.46948 0.875 4.4V9.789C0.875 10.7204 1.21869 11.6182 1.8427 12.2882L7.16252 18L1.82685 23.7288ZM4.29167 25.6992L10.5 19.0334L16.7083 25.6992V29.9C16.7083 30.7745 16.0436 31.475 15.25 31.475H5.75C4.95642 31.475 4.29167 30.7745 4.29167 29.9V25.6992ZM16.7083 10.3008L10.5 16.9666L4.29167 10.3008V6.1C4.29167 5.22552 4.95642 4.525 5.75 4.525H15.25C16.0436 4.525 16.7083 5.22552 16.7083 6.1V10.3008Z",
    fill: "#FF8A4A",
    stroke: "#FF8A4A",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassEmpty);
export default __webpack_public_path__ + "static/media/hourglass_empty.19a06a25f637c18cbb10d8c69f23f5fb.svg";
export { ForwardRef as ReactComponent };